export enum AuthenticationMethod {
  code = 'code',
  userAndPassword = 'user_and_password',
  faceRecognition = 'face_recognition',
  fingerprint = 'fingerprint',
  barcode = 'barcode',
  card = 'card',
  qr = 'qr',
}
